import { queueTrackingEvent } from '@library/tracking-integration'

const RECIPE_PREVIEW_SECTION = 'recipe_preview'

// Action names per the CwC homepage tracking spreadsheet (rows 12/13/15) — not prefixed with
// `cwc_`, matching every other event on that sheet.
type WeeklyMenuTrackingData = {
  action: 'clicked_cooked_by_you' | 'clicked_cooked_by_us' | 'ThisWeeksMenu Clicked'
  properties: {
    section: typeof RECIPE_PREVIEW_SECTION
  }
}

function trackWeeklyMenuEvent(data: WeeklyMenuTrackingData) {
  queueTrackingEvent<WeeklyMenuTrackingData>(data)
}

export function trackCookedByYouClick() {
  trackWeeklyMenuEvent({
    action: 'clicked_cooked_by_you',
    properties: { section: RECIPE_PREVIEW_SECTION },
  })
}

export function trackCookedByUsClick() {
  trackWeeklyMenuEvent({
    action: 'clicked_cooked_by_us',
    properties: { section: RECIPE_PREVIEW_SECTION },
  })
}

export function trackThisWeeksMenuClick() {
  trackWeeklyMenuEvent({
    action: 'ThisWeeksMenu Clicked',
    properties: { section: RECIPE_PREVIEW_SECTION },
  })
}
